import React from "react";

import {
  Content,
  Grid,
  GridItem,
  Icon,
  Label,
  LabelGroup,
  PageSection,
  Stack,
  StackItem
} from "@patternfly/react-core";

import {
  GraduationCapIcon
} from "@patternfly/react-icons";


const EducationDirectionFurtherEducation = ({
  furtherEducation = {}
}) => {
  const {
    description,
    fields = []
  } = furtherEducation;

  if (!description && !fields.length) {
    return null;
  }

  return (
    <PageSection
      id="further-education"
      className="education-direction-section"
      isWidthLimited
      variant="secondary"
      aria-labelledby="education-direction-further-education-title"
    >
      <Grid hasGutter>
        <GridItem
          span={12}
          md={4}
        >
          <Stack hasGutter>
            <StackItem>
              <Icon
                size="xl"
                // status="info"
              >
                <GraduationCapIcon />
              </Icon>
            </StackItem>

            <StackItem>
              <Content>
                <h2 id="education-direction-further-education-title">
                  Możesz rozwijać się dalej
                </h2>
              </Content>
            </StackItem>
          </Stack>
        </GridItem>

        <GridItem
          span={12}
          md={8}
        >
          <Stack hasGutter>
            {description && (
              <StackItem>
                <Content>
                  <p>{description}</p>
                </Content>
              </StackItem>
            )}

            {fields.length > 0 && (
              <>
                <StackItem>
                  <Content>
                    <h3>
                      Przykładowe kierunki studiów
                    </h3>
                  </Content>
                </StackItem>

                <StackItem>
                  <LabelGroup>
                    {fields.map((field) => (
                      <Label
                        key={field}
                        color="blue"
                        variant="outline"
                      >
                        {field}
                      </Label>
                    ))}
                  </LabelGroup>
                </StackItem>
              </>
            )}
          </Stack>
        </GridItem>
      </Grid>
    </PageSection>
  );
};


export default EducationDirectionFurtherEducation;